/** Auto-generated from public/imgs/mac88 — gameCode -> filename. Run: node scripts/gen-mac88-images.js [--rename] */
export const MAC88_LOCAL_IMAGE_BY_CODE: Record<string, string> = {
  '150000': "150000_Mac88_Gaming_Lobby.png",
  '150001': "150001__Dragon_Tiger.png",
  '150002': "150002_Bacarrat.png",
  '150003': "150003__Sic_Bo.png",
  '150004': "150004__Roulette.png",
  '150005': "150005__Poker_20-20.png",
  '150006': "150006_Lucky7.png",
  '150007': "150007__Andar_Bahar.png",
  '150009': "150009__Teenpatti_One_Day.png",
  '150010': "150010__32_Cards.png",
  '150013': "150013_DTL.png",
  '150014': "150014__Amar_Akbar_Anthony.png",
  '150015': "150015__3_Cards_Judgement.png",
  '150016': "150016__Queen_Race.png",
  '150017': "150017__Race_20.png",
  '150018': "150018__Casino_War.png",
  '150019': "150019__Worli_Matka.png",
  '150020': "150020__Lottery.png",
  '150023': "150023_Test_Teenpatti.png",
  '150025': "150025_Trio.png",
  '150026': "150026_29_Baccarat.png",
  '150028': "150028_Two_Card_Teenpatti.png",
  '150030': "150030_Muflis_Teenpatti.png",
  '150031': "150031_Bollywood_Casino_B.png",
  '150032': "150032_Poker_1-Day.png",
  '150033': "150033_20-20_Teenpatti.png",
  '150034': "150034_Super_Over.png",
  '150035': "150035_5_Five_Cricket.png",
  '150036': "150036_1_Day_Dragon_Tiger.png",
  '150037': "150037_Dus_Ka_Dum.png",
  '150038': "150038_One_Card_20_20.png",
  '150039': "150039_One_Card_Meter.png",
  '150040': "150040_One_Card_One_Day.png",
  '150041': "150041_6_Player_Poker.png",
  '150042': "150042_Instant_2_Cards_Teenpatti.png",
  '150043': "150043_Race_to_17.png",
  '150045': "150045_Note_Number.png",
  '150046': "150046_Cricket_Match_20-20.png",
  '150049': "150049_Open_Teen_patti.png",
  '150051': "150051_High_Low.png",
  '150053': "150053_10_-_10_cricket.png",
  '150054': "150054_Muflis_Teenpatti.png",
  '150056': "150056_Instant_Teen_Patti.png",
  '150057': "150057_Andar_Bahar_50.png",
  '150058': "150058_Super_Over.png",
  '150059': "150059_Center_card.png",
  '150062': "150062_Football_StudIo.png",
  '150063': "150063_Dream_Wheel.png",
  '150066': "150066__20_20_Teenpatti_2.png",
  '150067': "150067__Dragon_Tiger_2.png",
  '150068': "150068__Lucky_5.png",
  '150070': "150070__AK47_Teenpatti.png",
  '150071': "150071__Teenpatti_Joker_20-20.png",
  '150072': "150072__Teenpatti_Joker_One_Day.png",
  '150073': "150073__Turbo_Auto_Roulette.png",
  '150074': "150074__Speed_Auto_Roulette.png",
  '150075': "150075_Poison_Teenpatti_20_20.png",
  '150076': "150076_Unique_Teenpatti.png",
  '150077': "150077_Lightning_Dragon_Tiger.png",
  '150080': "150080_Sexy_Amar_Akbar_Anthony.png",
  '150085': "150085_Sexy_High_Low.png",
  '150087': "150087_Sexy_Lucky_7.png",
  '150599': "150599__MAC_Excite_Lobby.png",
  '150600': "150600_Dragon_Tiger.png",
  '150601': "150601__Baccarat.png",
  '150602': "150602_Sic_Bo.png",
  '150603': "150603_Roulette.png",
  '150604': "150604_Poker_20-20.png",
  '150605': "150605__Lucky_7.png",
  '150606': "150606_Andar_Bahar.png",
  '150607': "150607_Teenpatti_One_Day.png",
  '150608': "150608_32_Cards.png",
  '150609': "150609__Dragon_Tiger_Lion.png",
  '150610': "150610_Amar_Akbar_Anthony.png",
  '150611': "150611_3_Cards_Judgement.png",
  '150612': "150612_Queen_Race.png",
  '150613': "150613_Race_20.png",
  '150614': "150614_Casino_War.png",
  '150615': "150615_Worli_Matka.png",
  '150616': "150616_Lottery.png",
  '150617': "150617_Test_Teenpatti.png",
  '150619': "150619_Trio.png",
  '150620': "150620_29_Baccarat.png",
  '150621': "150621_Two_Card_Teenpatti.png",
  '150622': "150622_Muflis_Teenpatti_One_Day.png",
  '150623': "150623_Bollywood_Casino.png",
  '150624': "150624_Poker_1-Day.png",
  '150625': "150625_20-20_Teenpatti.png",
  '150626': "150626_Super_Over.png",
  '150627': "150627_5_Five_Cricket.png",
  '150628': "150628_1_Day_Dragon_Tiger.png",
  '150629': "150629_Dus_Ka_Dum.png",
  '150630': "150630_One_Card_20_20.png",
  '150633': "150633_6_Player_Poker.png",
  '150634': "150634_Instant_2_Cards_Teenpatti.png",
  '150635': "150635_Race_to_17.png",
  '150636': "150636_Note_Number.png",
  '150637': "150637_Cricket_Match_20-20.png",
  '150640': "150640_Open_Teen_patti.png",
  '150642': "150642_High_Low.png",
  '150644': "150644_10_-_10_cricket.png",
  '150645': "150645_20_20_Teenpatti_2.png",
  '150646': "150646_Dragon_Tiger_2.png",
  '150647': "150647_Muflis_Teenpatti.png",
  '150648': "150648_One_Card_One_Day.png",
  '150649': "150649_AK47_Teenpatti.png",
  '150650': "150650_Center_Card.png",
  '150651': "150651_Lucky_5.png",
  '150654': "150654_Instant_Super_Over.png",
  '150655': "150655_Instant_Teenpatti.png",
  '150656': "150656_Andar_Bahar_50.png",
  '150657': "150657_FootBall_Studio_Dice.png",
  '150658': "150658_Dream_Wheel.png",
  '150662': "150662_Joker_Teenpatti_One_Day.png",
  '150666': "150666_Speed_Auto_Roulette.png",
  '150667': "150667_Turbo_Auto_Roulette.png",
  '150668': "150668_Unique_Teenpatti.png",
  '150669': "150669_Poison_Teenpatti_20_20.png",
  '150900': "150900_Mini_Aviator.png",
  '150901': "150901_Mini_JetX.png",
  '150902': "150902_Mini_Dice.png",
  '150903': "150903_Mini_Limbo.png",
  '150904': "150904_Mini_Rock_Paper_Scissors.png",
  '150905': "150905_Mini_Fortune_Wheel.png",
  '150906': "150906_Mini_Coin_Flip.png",
  '150907': "150907_Mini_Crash_X.png",
  '150908': "150908_Mini_Xroulette.png",
  '151003': "151003__VR_Lucky_7.png",
  '151004': "151004__VR_Trio.png",
  '151005': "151005__VR_20-20_DTL.png",
  '151006': "151006__VR_Mulfis_Teenpatti.png",
  '151007': "151007__VR_Bollywood_Casino.png",
  '151008': "151008__VR_Amar_Akbar_Anthony.png",
  '151009': "151009__VR_Dragon_Tiger.png",
  '151010': "151010__VR_Casino_Meter.png",
  '151011': "151011__VR_20-20_Teenpatti.png",
  '151012': "151012__VR_32_Cards.png",
  '151014': "151014__VR_Andar_Bahar.png",
  '151015': "151015__VR_2_Card_TP.png",
  '151016': "151016__VR_Queen_Race.png",
  '151017': "151017__VR_Poker.png",
  '151018': "151018__VR_Race_T20.png",
  '151019': "151019__VR_Auto_Roulette.png",
  '151020': "151020__VR_High_low.png",
  '151021': "151021__VR_Worli_Matka.png",
  '151022': "151022__VR_29_card_bacarrat.png",
  '151026': "151026__Lankesh.png",
  '151027': "151027__Aviator_X.png",
  '151054': "151054__WINGO.png",
  '151058': "151058__5D_Lottery_1.png",
  '151062': "151062__K3_Lottery_1.png",
  '151067': "151067__AviatorX2.png",
  '151068': "151068__Hi_Lo_VR.png",
  '151069': "151069__Center_Card_VR.png",
  '151071': "151071__AK47_VR.png",
  '151072': "151072__Crash_X.png",
  '151073': "151073__Limbo.png",
  '151074': "151074__Dice.png",
  '151075': "151075__Mines.png",
  '151076': "151076__Diamonds.png",
  '151077': "151077__Plinko.png",
  '151078': "151078_Lucky_5.png",
  '151080': "151080_Vortex.png",
  '151081': "151081__Lucky_15.png",
  '151082': "151082__X_Roulette.png",
  '151083': "151083__Ball_by_Ball_VR.png",
  '151084': "151084__Pushpa_Rani.png",
  '151085': "151085__Hi_Lo.png",
  '151086': "151086__Kitex.png",
  '151087': "151087__Jet_XT.png",
  '151095': "151095__Rock_Paper_Scissors.png",
  '151098': "151098__Sky_fall.png",
  '151099': "151099__Trade88_RNG.png",
  '151100': "151100__Coin_Flip.png",
  '151101': "151101__Fortune_Wheel.png",
  '151102': "151102_Chicken_Road_Cross_2.png",
  '151108': "151108__Trade88_EURUSD.png",
  '151114': "151114_Trade88_ETHUSD.png",
  '151116': "151116__Trade88_BNBUSD.png",
  '151117': "151117__Trade88_BTCUSD.png",
  '151118': "151118__Trade88_LTCUSD.png",
  '151119': "151119__Trade88_GOLD.png",
  '151120': "151120__Trade88_SILVER.png",
  '151121': "151121__Trade88_OIL.png",
  '151122': "151122_Trade88_NATURAL_GAS.png",
  '151132': "151132__Chicken_Road_Cross.png",
  '151133': "151133__Jhandi_Munda.png",
  '151151': "151151__Color_Game.png",
  '151154': "151154_Race_Track.png",
  '151155': "151155_Stock_Matka.png",
  '151156': "151156__Pick3_1min.png",
  '151162': "151162_Pump.png",
  '151163': "151163_Dragon_Tower.png",
  '151164': "151164_Packs.png",
  '151165': "151165_Naughty_Button.png",
  '151166': "151166_Jalwa_Color_Game.png",
  '151170': "151170_Snakes.png",
  '151171': "151171_Trade88_SOLUSD.png",
  '151172': "151172_Trade88_ETHUSD.png",
  '151174': "151174_CRASH_MAN.png",
  '151175': "151175_Plane_Crash.png",
  '151178': "151178_The_Voice.png",
  '151179': "151179_Deal_Or_No_Deal.png",
  '151180': "151180_VR_Lightning_Roulette.png",
  '151182': "151182_Lucky_Tiger_Mines.png",
  '151184': "151184_Trade88_RNG2.png",
  '151187': "151187_Marble_Run.png",
}

export const MAC88_LOCAL_IMAGE_BASE = '/imgs/mac88'
